/* tslint:disable:no-any */
import { cloneDeep, isEqual } from 'lodash';
import { isNil } from '../../utils';
import { SerializableObjectBuildError } from '../errors/serializable-object-build.error';

/**
 * Base Domain Object
 */
export abstract class SerializableObject {
  /**
   * Domain object constructor.
   * @param json Optional json used to populate the domain object fields.
   */
  constructor(json?: any) {
    // TODO: Refactor constructors with type arguments and remove this extra check.
    if (!isNil(json)) {
      this.buildFromJSON(json);
    }
  }

  /**
   * Builds the domain object fields from the provided json.
   * @param json The json object
   *
   * TODO: Update all sub classes to emit SerializableObjectBuildError.
   */
  public buildFromJSON(json: any): void {
    if (isNil(json)) {
      return;
    }

    try {
      let primitiveProperties: string[] = Object.keys(json);
      primitiveProperties.forEach((property: string): void => {
        (this as any)[property] = this.coercePropertyType(property, json[property]);
      });
    } catch (err) {
      throw new SerializableObjectBuildError('Failed to build object', err);
    }
  }

  /**
   * Clones the current SerializableObject.
   */
  public clone(): any {
    return cloneDeep(this);
  }

  /**
   * Performs a deep comparison between objects to determine if they are equivalent.
   */
  public isClone(otherObj: any): boolean {
    if (this === otherObj) {
      // Don't count the references to the same object as equivalent objects.
      return false;
    }

    return isEqual(this, otherObj);
  }

  /**
   * Coerce property value type. Override this method to convert properties to proper types.
   *
   * NOTE: When overriding in a sub-class, always call the parent method.
   *
   * @param _property The property name
   * @param value The property value
   */
  protected coercePropertyType(_property: string, value: any): any {
    if (isNil(value)) {
      // TODO: Return undefined.
      return null;
    }
    return value;
  }
}
